import { getConfig } from '@/views/first_payment/const'
const config = {"qrcode_img": "https://cdn.vip-wifi.com/fangchan/config/pages/taxes_calculate/taxes_calculate.jpeg"}
const path = "/taxes_calculate/config.json"

export default {
    data () {
        return {
            qrcode_img: ''
        }
    },
    mounted () {
        this.getConfig()
    },
    methods: {
        getConfig () {
            getConfig({config, path}).then(({ qrcode_img}) => {
                this.qrcode_img = qrcode_img
            })
        }
    }
}